import { render, staticRenderFns } from "./BackToInventory.vue?vue&type=template&id=acb0b772&scoped=true&"
import script from "./BackToInventory.vue?vue&type=script&lang=js&"
export * from "./BackToInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb0b772",
  null
  
)

export default component.exports